





































































































































































import { createComponent } from "@vue/composition-api";
import { UploadedImage } from "../api";
import { REPORT_TYPE } from "../types";

export default createComponent({
  props: {
    previewImages: {
      type: Array,
      default: []
    },
    uploading: {
      default: false
    },
    error: {
      default: null
    },
    onClickRemoveImage: {
      type: Function
    },
    submit: {
      type: Function
    },
    valid: {
      type: Boolean,
      default: false
    },
    formState: {
      type: Object
    },
    submitText: {
      type: String
    },
    disableProgressiveUpload: {
      type: Boolean,
      default: false
    }
  },
  name: "ImageUploadForm",
  setup(props, context) {
    const reportTypeItems: Array<{ text: string; value?: string }> = [
      ...REPORT_TYPE
    ];
    const GROUND_TYPES = [
      "森林(天然林)",
      "森林(人工林)",
      "森林(次生林)",
      "溪流或河床",
      "住宅房舍附近",
      "遊憩區(包括山屋 / 營地週遭)",
      "道路(步道)",
      "道路(馬路)",
      "道路(林道)",
      "道路(產業道路)",
      "農牧用地(果園)",
      "農牧用地(菜園)",
      "農牧用地(休耕地)",
      "農牧用地(養蜂場)",
      "農牧用地(禽舍)",
      "農牧用地(豬舍)",
      "農牧用地(工寮或倉庫)",
      "其他"
    ];
    const VEGETATIONS = [
      "闊葉林",
      "針葉林",
      "混合林",
      "灌叢",
      "草原",
      "竹林/箭竹林",
      "裸露地",
      "其他"
    ];
    const BEAR_ATTRACTORS = [
      "無",
      "自然食物資源",
      "動物屍體",
      "農作物",
      "家禽/畜",
      "蜂蜜",
      "垃圾/廚餘",
      "動物飼料",
      "人類食物",
      "其他"
    ];

    return {
      images: [],
      GROUND_TYPES,
      VEGETATIONS,
      BEAR_ATTRACTORS,
      onChange: function (e: InputEvent) {
        context.emit("input", (e.target as HTMLInputElement).files);
      },
      onSubmit() {
        if (props.valid && props.formState && props.formState.type && typeof props.submit === "function") {
          props.submit();
        }
      },
      removeImage: (image: UploadedImage) => {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        props.onClickRemoveImage!(image);
      },
      reportTypeItems
    };
  }
});
